import { createGlobalStyle } from "styled-components";

/**
 * App-wide default SweetAlert2 button colours. Popups that pass their own
 * `confirmButtonColor`/`cancelButtonColor` still win, as those are inline styles.
 */
export const SweetAlertGlobalStyle = createGlobalStyle({
    ".swal2-container": {
        "--swal2-confirm-button-background-color": "#3085d6",
        "--swal2-cancel-button-background-color": "#aaa",
    },
});
